import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [lama, setLama] = useState("");
  const [baru, setBaru] = useState("");
  const [ulang, setUlang] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (baru.length < 8) { toast.error("Password baru minimal 8 karakter"); return; }
    if (baru !== ulang) { toast.error("Konfirmasi password tidak sama"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { password_lama: lama, password_baru: baru });
      setUser({ ...user, must_change_password: false });
      toast.success("Password berhasil diubah");
      navigate("/");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="max-w-md mx-auto space-y-5" data-testid="change-password-page">
      <h1 className="text-2xl font-bold tracking-tight text-slate-900">Ganti Password</h1>
      {user?.must_change_password && <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2" data-testid="must-change-msg">Demi keamanan, silakan ganti password awal Anda.</p>}
      <Card className="p-5 rounded-2xl space-y-4">
        <div><Label className="text-sm font-medium text-slate-700 mb-1.5 block">Password Lama</Label><Input type="password" data-testid="pw-lama" value={lama} onChange={(e) => setLama(e.target.value)} className="min-h-[44px] rounded-xl" /></div>
        <div><Label className="text-sm font-medium text-slate-700 mb-1.5 block">Password Baru</Label><Input type="password" data-testid="pw-baru" value={baru} onChange={(e) => setBaru(e.target.value)} className="min-h-[44px] rounded-xl" /></div>
        <div><Label className="text-sm font-medium text-slate-700 mb-1.5 block">Ulangi Password Baru</Label><Input type="password" data-testid="pw-ulang" value={ulang} onChange={(e) => setUlang(e.target.value)} className="min-h-[44px] rounded-xl" /></div>
        <Button onClick={submit} disabled={saving} className="w-full min-h-[48px] rounded-xl bg-[hsl(224,64%,33%)] hover:bg-[hsl(224,64%,28%)]" data-testid="save-password-btn">{saving ? "Menyimpan..." : "Simpan Password"}</Button>
      </Card>
    </div>
  );
}
